<!--
@Author: Colin Osterhout <ctosterhout>
@Date:   2019-07-19T15:40:03-08:00
@Email:  ctosterhout@alaska.edu
@Project: ernie
@Last modified by:   ctosterhout
@Last modified time: 2020-01-31T10:09:39-09:00
@License: Released under MIT License. Copyright 2019 University of Alaska Southeast.  For more details, see https://opensource.org/licenses/MIT
-->

<template>
<div class="page-scroller-wrapper">
  <transition name="fadeScrollUp"
              enter-active-class="animated fadeIn faster"
              leave-active-class="animated fadeOut fast">
    <a v-if="scrollUpVisible"
       key="scrollUp"
       href="javascript:;"
       class="page-scroller page-scroller-up d-block"
       @click="scrollUp">
      <span class="sr-only">Navigate back to top</span>
      <Icon>
        <Icon name="circle"
              class="icon-background"
              scale="2" />
        <Icon name="arrow-up"
              class="icon-foreground"
              scale="1.25"/>
      </Icon>
    </a>
  </transition>
  <transition name="fadeScrollDown"
              enter-active-class="animated fadeIn slow"
              leave-active-class="animated fadeOut faster">
    <a v-if="scrollDownVisible"
       key="scrollDown"
       href="javascript:;"
       class="page-scroller page-scroller-down d-none d-md-block"
       @click="scrollDown">
      <span class="sr-only">Navigate down the page</span>
      <Icon>
        <Icon name="circle"
              class="icon-background"
              scale="4" />
        <Icon name="chevron-down"
              class="icon-foreground"
              scale="2.75" />
      </Icon>
    </a>
  </transition>
</div>
</template>

<style lang="scss" scoped>
$color-icon-foreground: #024a7d;
$color-icon-background: #C5D645;

.page-scroller {
    position: fixed;
    text-align: center;
    z-index: 1;
    outline: none;
}

.page-scroller-down {
    left: 50%;
    bottom: 0;
    transform: translate(-50%, -20%);
    width: 5em;
    height: 5em;
    padding-top: 0.7em;
    font-size: 1em;
}

.page-scroller-up {
    right: 3%;
    bottom: 3%;
    font-size: 1em;
    width: 2em;
    height: 2em;
}

.icon-background {
    color: $color-icon-background;
}

.icon-foreground {
    color: $color-icon-foreground;
}

</style>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/circle'
import 'vue-awesome/icons/chevron-down'
import 'vue-awesome/icons/arrow-up'
import $ from 'jquery'
import _ from 'lodash'

const $window = $(window)
const debounceTime = 100
const initDelayTime = 2000

// Create event handler on the main window to handle scrolls
const isWindowScrolled = function () {
  return $window.scrollTop() > 0
}

export default {
  name: 'PageScroller',
  data: function () {
    return {
      scrollUpVisible: false,
      scrollDownVisible: false,
      scrollDownHasShown: isWindowScrolled()
    }
  },
  props: {
    delayTime: {
      type: Number,
      default: initDelayTime
    },
    disableScrollDown: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Icon
  },
  created: function () {
    // Set up the event handler on the main window
    $window.scroll(_.debounce(() => {
      this.checkPosition()
    }, debounceTime))

    // Set up the initial fade in if necessary
    setTimeout(this.checkPosition, initDelayTime)
  },
  methods: {
    // Set the icon visibility based on the window scroll position
    checkPosition: function () {
      if (isWindowScrolled()) {
        this.hideScrollDown()
        this.showScrollUp()
      } else {
        this.showScrollDown()
        this.hideScrollUp()
      }
    },
    // Only apply this function one time - the user only needs to be shown once.
    showScrollDown: function () {
      this.scrollDownVisible = !this.scrollDownHasShown && !this.disableScrollDown && true
      this.scrollDownHasShown = true
    },
    showScrollUp: function () {
      this.scrollUpVisible = true
    },
    hideScrollUp: function () {
      this.scrollUpVisible = false
    },
    hideScrollDown: function () {
      this.scrollDownVisible = false
    },
    scrollDown: function () {
      const offset = $(window).height()

      $('html,body').animate({
        scrollTop: offset
      }, 500)
    },
    scrollUp: function () {
      $('html,body').animate({
        scrollTop: 0
      }, 500)
    }
  }
}
</script>
